import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";

import GroupAddIcon from "@material-ui/icons/GroupAdd";
import GroupIcon from "@material-ui/icons/Group";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CancelIcon from "@material-ui/icons/Cancel";
import SendIcon from "@material-ui/icons/Send";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import TuneIcon from "@material-ui/icons/Tune";

import { makeStyles } from "@material-ui/core/styles";
import { toast } from "sonner";

import CardCounter from "../../components/Dashboard/CardCounter";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import useDashboard from "../../hooks/useDashboard";
import useCompanies from "../../hooks/useCompanies";

import { ChartsDate } from "./ChartsDate";
import { ChartsQueue } from "./ChartsQueue";
import { ChartsUser } from "./ChartsUser";

import { isEmpty } from "lodash";
import moment from "moment";

import TableTempMedioStatus from "../../components/Dashboard/TableTempoMedioStatus";
import TableTempWaitStatus from "../../components/Dashboard/TableTempoWaitStatus";
import api from "../../services/api";
import MainContainer from "../../components/MainContainer";

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    padding: theme.spacing(2, 3),
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 4,
  },
  sectionTitle: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
  },
  sectionSubtitle: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 13,
    fontWeight: 400,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    marginBottom: 20,
  },
  filterIconBtn: {
    width: 38,
    height: 38,
    borderRadius: 10,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "#E2E8F0",
    },
  },
  filterPopover: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
    minWidth: 280,
    maxWidth: 320,
    borderRadius: 14,
  },
  filterPopoverTitle: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
  },
  filterSelect: {
    width: "100%",
    "& .MuiInputBase-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
    "& .MuiInputLabel-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
  },
  filterDate: {
    width: "100%",
    "& .MuiInputBase-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
    "& .MuiInputLabel-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
  },
  filterButton: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontWeight: 600,
    fontSize: 13,
    textTransform: "none",
    borderRadius: 10,
    padding: "8px 24px",
    backgroundColor: "#35af9a",
    color: "#FFFFFF",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "#2d9a87",
      boxShadow: "0 2px 8px rgba(53,175,154,0.3)",
    },
  },
  chartCard: {
    borderRadius: 14,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9"}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    padding: "20px",
    backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );

  const getLastDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .split("T")[0];
  };

  const [dateTo, setDateTo] = useState(getLastDayOfMonth(new Date()));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();
  const { finding } = useCompanies();
  const [contagemEncerrados, setContagemEncerrados] = useState(null);
  const [clickFilter, setClickFIlter] = useState(false);
  const [messagesCount, setMessagesCount] = useState({ sent: 0, received: 0 });

  // Filter popover
  const [filterAnchor, setFilterAnchor] = useState(null);
  const filterOpen = Boolean(filterAnchor);

  useEffect(() => {
    async function firstLoad() {
      await fetchData();
    }
    setTimeout(() => {
      firstLoad();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleChangePeriod(value) {
    setPeriod(value);
  }

  async function handleChangeFilterType(value) {
    setFilterType(value);
    if (value === 1) {
      setPeriod(0);
    } else {
      setDateFrom("");
      setDateTo("");
    }
  }

  function getEffectiveDates() {
    const defaultFrom = moment().startOf("month").format("YYYY-MM-DD");
    const defaultTo = moment().endOf("month").format("YYYY-MM-DD");

    if (period > 0) {
      return {
        date_from: moment().subtract(period, "days").format("YYYY-MM-DD"),
        date_to: moment().format("YYYY-MM-DD"),
      };
    }

    return {
      date_from: !isEmpty(dateFrom) && moment(dateFrom).isValid()
        ? moment(dateFrom).format("YYYY-MM-DD")
        : defaultFrom,
      date_to: !isEmpty(dateTo) && moment(dateTo).isValid()
        ? moment(dateTo).format("YYYY-MM-DD")
        : defaultTo,
    };
  }

  async function fetchData() {
    setLoading(true);

    let params = {};

    if (period > 0) {
      params = { days: period };
    }

    if (!isEmpty(dateFrom) && moment(dateFrom).isValid()) {
      params = { ...params, date_from: moment(dateFrom).format("YYYY-MM-DD") };
    }

    if (!isEmpty(dateTo) && moment(dateTo).isValid()) {
      params = { ...params, date_to: moment(dateTo).format("YYYY-MM-DD") };
    }

    if (Object.keys(params).length === 0) {
      params = {
        date_from: moment().startOf("month").format("YYYY-MM-DD"),
        date_to: moment().endOf("month").format("YYYY-MM-DD"),
      };
    }

    const data = await find(params);

    setCounters(data.counters);
    if (isArray(data.attendants)) {
      setAttendants(data.attendants);
    } else {
      setAttendants([]);
    }

    setLoading(false);
  }

  useEffect(() => {
    async function fetchData() {
      await loadCompanies();
    }
    fetchData();
    chatsEncerrados();
    fetchMessagesCount();
  }, []);

  const companyId = localStorage.getItem("companyId");

  const loadCompanies = async () => {
    setLoading(true);
    try {
      await finding(companyId);
    } catch (e) {
      // silently fail
    }
    setLoading(false);
  };

  const chatsEncerrados = async () => {
    try {
      const effective = getEffectiveDates();
      const params = { initialDate: effective.date_from, finalDate: effective.date_to };
      const { data } = await api.get("/dashboard/atendimentos-encerrados", {
        params,
      });
      setContagemEncerrados(data);
    } catch (e) {
      // silently fail
    }
  };

  const fetchMessagesCount = async () => {
    try {
      const { data } = await api.get("/dashboard/messages-count");
      setMessagesCount(data);
    } catch (e) {
      // silently fail
    }
  };

  const handleFilterButtonClick = async () => {
    setFilterAnchor(null);
    await fetchData();
    await chatsEncerrados();
    await fetchMessagesCount();
    setClickFIlter((prev) => !prev);
  };

  return (
    <MainContainer>
      <Box className={classes.dashboardContainer}>
        {/* Header */}
        <Box className={classes.headerRow}>
          <Typography className={classes.sectionTitle}>Dashboard</Typography>
          <Tooltip title="Filtros">
            <IconButton
              className={classes.filterIconBtn}
              onClick={(e) => setFilterAnchor(e.currentTarget)}
            >
              <TuneIcon style={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Typography className={classes.sectionSubtitle}>
          Acompanhe as métricas do seu atendimento
        </Typography>

        {/* Filter Popover */}
        <Popover
          open={filterOpen}
          anchorEl={filterAnchor}
          onClose={() => setFilterAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            className: classes.filterPopover,
          }}
        >
          <Typography className={classes.filterPopoverTitle}>
            Filtros
          </Typography>

          <FormControl
            variant="outlined"
            size="small"
            className={classes.filterSelect}
          >
            <InputLabel id="filter-type-label">Tipo de Filtro</InputLabel>
            <Select
              labelId="filter-type-label"
              value={filterType}
              onChange={(e) => handleChangeFilterType(e.target.value)}
              label="Tipo de Filtro"
            >
              <MenuItem value={1}>Filtro por Data</MenuItem>
              <MenuItem value={2}>Filtro por Período</MenuItem>
            </Select>
          </FormControl>

          {filterType === 1 ? (
            <>
              <TextField
                label="Data Inicial"
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className={classes.filterDate}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
              />
              <TextField
                label="Data Final"
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className={classes.filterDate}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
              />
            </>
          ) : (
            <FormControl
              variant="outlined"
              size="small"
              className={classes.filterSelect}
            >
              <InputLabel id="period-selector-label">Período</InputLabel>
              <Select
                labelId="period-selector-label"
                id="period-selector"
                value={period}
                onChange={(e) => handleChangePeriod(e.target.value)}
                label="Período"
              >
                <MenuItem value={0}>Nenhum selecionado</MenuItem>
                <MenuItem value={3}>Últimos 3 dias</MenuItem>
                <MenuItem value={7}>Últimos 7 dias</MenuItem>
                <MenuItem value={15}>Últimos 15 dias</MenuItem>
                <MenuItem value={30}>Últimos 30 dias</MenuItem>
                <MenuItem value={60}>Últimos 60 dias</MenuItem>
                <MenuItem value={90}>Últimos 90 dias</MenuItem>
              </Select>
              <FormHelperText>Selecione o período desejado</FormHelperText>
            </FormControl>
          )}

          <Button
            variant="contained"
            className={classes.filterButton}
            onClick={handleFilterButtonClick}
            disabled={loading}
          >
            Filtrar
          </Button>
        </Popover>

        {/* Counter Cards */}
        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={<GroupAddIcon style={{ fontSize: 26, color: "#35af9a" }} />}
              iconBg="#EBF5F3"
              title="Chats Pendentes"
              value={counters.supportPending}
              loading={loading}
              infoTitle="Chats Pendentes"
              infoContent="Tickets aguardando na fila para serem atendidos por um operador."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={<GroupIcon style={{ fontSize: 26, color: "#3B82F6" }} />}
              iconBg="#EFF6FF"
              title="Chats Ativos"
              value={counters.supportHappening}
              loading={loading}
              infoTitle="Chats Ativos"
              infoContent="Tickets com atendimento em andamento (abertos)."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={
                <AssignmentTurnedInIcon
                  style={{ fontSize: 26, color: "#8B5CF6" }}
                />
              }
              iconBg="#F3F0FF"
              title="Chats Concluídos"
              value={counters.supportFinished}
              loading={loading}
              infoTitle="Chats Concluídos"
              infoContent="Tickets cujo atendimento foi concluído (status fechado) no período selecionado."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={<CancelIcon style={{ fontSize: 26, color: "#EF4444" }} />}
              iconBg="#FEF2F2"
              title="Chats Encerrados"
              value={contagemEncerrados}
              loading={loading}
              infoTitle="Chats Encerrados"
              infoContent="Total de atendimentos registrados no período selecionado."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={<SendIcon style={{ fontSize: 24, color: "#F59E0B" }} />}
              iconBg="#FFFBEB"
              title="Msgs Enviadas"
              value={messagesCount.sent}
              loading={loading}
              infoTitle="Mensagens Enviadas"
              infoContent="Total de mensagens enviadas pela empresa no período."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CardCounter
              icon={
                <CallReceivedIcon style={{ fontSize: 24, color: "#06B6D4" }} />
              }
              iconBg="#ECFEFF"
              title="Msgs Recebidas"
              value={messagesCount.received}
              loading={loading}
              infoTitle="Mensagens Recebidas"
              infoContent="Total de mensagens recebidas dos contatos no período."
            />
          </Grid>
        </Grid>

        {/* Highlight cards row */}
        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid item xs={12} sm={6}>
            <TableTempMedioStatus
              attendants={attendants}
              loading={loading}
              dataini={dateFrom}
              dataFinal={dateTo}
              reload={clickFilter}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            {attendants.length ? (
              <TableTempWaitStatus
                attendants={attendants}
                loading={loading}
                dataini={dateFrom}
                dataFinal={dateTo}
                reload={clickFilter}
              />
            ) : null}
          </Grid>
        </Grid>

        {/* Attendants Table */}
        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid item xs={12}>
            {attendants.length ? (
              <TableAttendantsStatus
                attendants={attendants}
                loading={loading}
                dataini={dateFrom}
                dataFinal={dateTo}
              />
            ) : null}
          </Grid>
        </Grid>

        {/* Charts Row */}
        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} className={classes.chartCard}>
              <ChartsQueue />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={0} className={classes.chartCard}>
              <ChartsUser />
            </Paper>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid item xs={12}>
            <Paper elevation={0} className={classes.chartCard}>
              <ChartsDate />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default Dashboard;
